export const STUDIO = {
  name: "Sculpt Fusion",
  address: "828 N Imperial Ave, El Centro, CA 92243",
  phone: "442-297-6472",
  phoneHref: "tel:+14422976472",
  email: "luzaidaperrone711@gmail.com",
  instagram: "@sculptfusion",
  venmo: "@Luzaida-Perrone-1",
  zelle: "442-297-6472",
};

export const WAIVER_PDF = "https://customer-assets-eiarnc6j.emergentagent.net/job_sculpt-neon/artifacts/6w8bnjzl_Sculpt_Fusion_Short_Liability_Waiver.pdf";
export const VENMO_QR = "https://customer-assets-eiarnc6j.emergentagent.net/job_sculpt-neon/artifacts/x0s1qfyq_venmo%20luz.JPG";

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/bb214338-2eb9-4d6d-a7a6-f867f46b2647/images/e49b5e7a9f79fc52a26d4f6b678f65aea22d3f72410d8bb6a682dd076d19a461.jpeg",
  m1: "https://customer-assets-eiarnc6j.emergentagent.net/job_sculpt-neon/artifacts/jzhy4xxq_3aff078d-ffbe-4100-b008-db443757099b.JPG",
  m2: "https://customer-assets-eiarnc6j.emergentagent.net/job_sculpt-neon/artifacts/g8wg2eqh_886da1b8-af64-46e9-815d-86ff0fef0849.JPG",
  m3: "https://static.prod-images.emergentagent.com/jobs/bb214338-2eb9-4d6d-a7a6-f867f46b2647/images/47930398f2d78fc732fc2c9efca0efa08e465ffb2c69eb7c2e06b72f640595e2.jpeg",
  studio: "https://customer-assets-eiarnc6j.emergentagent.net/job_sculpt-neon/artifacts/g8wg2eqh_886da1b8-af64-46e9-815d-86ff0fef0849.JPG",
  ring: "https://customer-assets-eiarnc6j.emergentagent.net/job_sculpt-neon/artifacts/cuvnysjh_2f0e084e-6ecc-42ea-b21b-b490d73867d3.JPG",
  weights: "https://customer-assets-eiarnc6j.emergentagent.net/job_sculpt-neon/artifacts/n18aydmz_3f605e43-bd44-4580-b023-ad79abbaaa47.JPG",
  bands: "https://customer-assets-eiarnc6j.emergentagent.net/job_sculpt-neon/artifacts/prs0mmh4_da36f91a-4a59-4d9f-8ddc-ca98b0e38df7.JPG",
};
